var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperCut22Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 420,
    height: 22,
    viewBox: "0 0 420 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 11,
    height: 22,
    transform: "translate(50 117)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 12,
    height: 17,
    transform: "translate(458 119)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(-50 -117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M8,0l8,8H0Z",
    transform: "translate(57 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(73 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(88 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(103 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-5",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(118 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-6",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(133 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-7",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(148 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-8",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(163 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-9",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(178 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-10",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(193 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-11",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(208 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-12",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(223 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-13",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(238 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-14",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(253 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-15",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(268 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-16",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(283 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-17",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(298 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-18",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(313 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-19",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(328 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-20",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(343 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-21",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(358 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-22",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(373 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-23",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(388 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-24",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(403 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-25",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(418 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-26",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(433 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-27",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(448 123.5)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-28",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(42.5 123.5)",
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-29",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,8H0Z",
    transform: "translate(462 123.5)",
    fill: "#f8f8f8"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCut22Px);
export default __webpack_public_path__ + "static/media/paper-cut-22px.804f91a4.svg";
export { ForwardRef as ReactComponent };